import { reportsApi } from 'Api/axios/reports-api';
import useEmployeeApi from 'Hooks/useEmployeeApi';
import useEmployeeCoursesReportApi from 'Hooks/useEmployeeCoursesReportApi';
import useTranslation from 'Hooks/useTranslation';
import { EmployeeCoursesReportFilterI } from 'types';
import { downloadFile } from 'Utils/file-utils';
import { useEffect, useState } from 'react';
import coursesApi from 'Api/axios/courses-api';
import { toast } from 'sonner';

const useEmployeeCoursesReportPage = (employeeId: string) => {
  const { t2 } = useTranslation('employees_courses_report');
  const [currentFilters, setCurrentFilters] = useState<EmployeeCoursesReportFilterI>({});

  const { employee, fetchEmployeeById, loading: employeeLoading, error: employeeError } = useEmployeeApi();

  const {
    data: coursesReportData,
    loading: coursesReportLoading,
    error: coursesReportError,
    fetchEmployeeCourses,
    fetchEmployeeCoursesTotals,
    totals: coursesReportTotals,
  } = useEmployeeCoursesReportApi({ employeeId, init: true });

  const handleSearch = (filters: EmployeeCoursesReportFilterI) => {
    setCurrentFilters(filters);
    fetchEmployeeCourses(employeeId, filters);
  };

  const handleExport = async () => {
    const response = await reportsApi.exportCoursesByEmployee(employeeId, currentFilters);

    if (response.data) {
      downloadFile(response.data, `${employee?.fullName}_cursos.xlsx`);
    }
  };

  // todo(kevin-iconos): eliminar este método para utilizar el de #utils
  const handleDownloadCertificate = async (coursesId: string, employeeId: string, certificationId: string) => {
    try {
      const response = await coursesApi.downloadCertificate(coursesId, employeeId, certificationId);
      if (response.data) {
        downloadFile(response.data, `certificado_${employee?.fullName}.pdf`);
        toast.success(t2('certificate_downloaded'));
      }
    } catch (error) {
      console.error('Error downloading certificate:', error);
    }
  };

  useEffect(() => {
    fetchEmployeeById(employeeId);
    fetchEmployeeCoursesTotals(employeeId);
  }, [employeeId]);

  return {
    coursesReportData,
    coursesReportLoading,
    coursesReportError,
    employee,
    employeeLoading,
    employeeError,
    fetchEmployeeById,
    t2,
    handleSearch,
    handleExport,
    currentFilters,
    coursesReportTotals,
    fetchEmployeeCoursesTotals,
    handleDownloadCertificate,
  };
};

export default useEmployeeCoursesReportPage;
